














































































































































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import swal from "sweetalert";
import Api from "@/api";
import { AxiosResponse } from "axios";

import FormErrorsMixin from "@/mixins/FormErrors";
import ViewLoader from "@/components/Common/ViewLoader.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import BackButton from "@/components/Common/Buttons/BackButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import GroupActions from "@/components/Settings/Groups/GroupActions.vue";
import Error404 from "@/components/Common/Error404.vue";
import { ICustomer, ICustomerGroup } from "@/interface";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    GroupActions,
    InfoButton,
    BackButton,
    DangerButton,
    Error404
  }
})
export default class Group extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = ["name", "description"];
  private noDataExist = false;
  private originalName: string | null = null;
  private selectedGroup: ICustomerGroup = {
    name: null,
    description: null,
    locked: null
  };
  private selectedGroupId: string | null = null;
  private failedRequest = false;
  // customers data
  private customers: Array<ICustomer> = [];
  private customersLength = 0;
  private currentPage = 1;
  private total = 0;
  private from = 0;
  private to = 0;
  private firstPage = 1;
  private lastPage: number | null = null;
  private perPage: number | null = null;
  private searchFilter = "";

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedGroupId = vm.$route.params.group_id;
      if (
        typeof vm.selectedGroupId !== "undefined" &&
        vm.selectedGroupId !== null
      ) {
        if (vm.$route.query.group_created === "true") {
          swal("Success!", "The group was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
        vm.getGroup(() => {
          //
        });
        vm.getGroupCustomers();
      }
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (
      typeof this.selectedGroupId !== "undefined" &&
      this.selectedGroupId !== null
    ) {
      this.getGroup(() => {
        //
      });
      this.getGroupCustomers();
    }
    next();
  }

  private createOrUpdateGroup(): void {
    if (this.selectedGroupId == null) {
      this.createGroup();
    } else {
      this.updateGroup();
    }
  }

  private createGroup(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint("groups");

    Api()
      .post(endpoint, this.selectedGroup)
      .then((response: AxiosResponse) => {
        this.selectedGroupId = response.data.data.id;
        this.$router.push({
          name: "GroupDetails",
          params: { group_id: `${this.selectedGroupId}` },
          query: { group_created: "true" }
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#group-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private getGroup(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "groups/" + this.selectedGroupId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedGroup = response.data.data;
        if (this.selectedGroup.name) {
          this.originalName = this.selectedGroup.name;
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateGroup(): void {
    if (this.loading || this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "groups/" + this.selectedGroupId
    );

    Api()
      .put(endpoint, this.selectedGroup)
      .then(() => {
        this.getGroup(() => {
          //
        });
        swal({
          title: "Success!",
          text: "The group was updated.",
          icon: "success"
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#group-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteGroup(): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The group will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "groups/" + this.selectedGroupId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router.push({
              name: "GroupsOverview",
              query: { group_deleted: "true" }
            });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete groups.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private getGroupCustomers(successCallback?: any): void {
    this.customers = [];
    const endpoint = this.$partnerEndpoint(
      "groups/" + this.selectedGroupId + "/customers"
    );

    Api()
      .get(endpoint, {
        params: { page: this.currentPage, search: this.searchFilter }
      })
      .then((response: AxiosResponse) => {
        this.customers = response.data.data;
        this.currentPage = response.data.meta.current_page;
        this.total = response.data.meta.total;
        this.from = response.data.meta.from;
        this.to = response.data.meta.to;
        this.lastPage = response.data.meta.last_page;
        this.perPage = response.data.meta.per_page;
        this.customersLength = this.customers.length;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private goToFirstPage(): void {
    if (!this.disabledFirstPage) {
      this.currentPage = 1;
      this.getGroupCustomers(() => {
        //
      });
    }
  }

  private goToPreviousPage(): void {
    if (!this.disabledPreviousPage) {
      this.currentPage--;
      this.getGroupCustomers(() => {
        //
      });
    }
  }

  private goToNextPage(): void {
    if (!this.disabledNextPage) {
      this.currentPage++;
      this.getGroupCustomers(() => {
        //
      });
    }
  }

  private goToLastPage(): void {
    if (!this.disabledLastPage) {
      if (this.lastPage) {
        this.currentPage = this.lastPage;
      }
      this.getGroupCustomers(() => {
        //
      });
    }
  }

  get disabledFirstPage(): boolean {
    return this.currentPage === 1;
  }

  get disabledPreviousPage(): boolean {
    return this.currentPage === 1;
  }

  get disabledNextPage(): boolean {
    return this.currentPage === this.lastPage;
  }

  get disabledLastPage(): boolean {
    return this.currentPage === this.lastPage;
  }
}
